
export default function Testimonials() {
  const testimonials = [
    {
      text: 'Incredible professional attitude and did a fantastic job! We have used Brushour twice now and been very impressed with Daniel, who is very knowledgeable and really went the extra mile to make our house look amazing.',
      author: 'Oliver Sharman',
      location: 'Watford',
      rating: 5,
      image: 'https://images.builderservices.io/s/cdn/v1.0/i/m?url=https%3A%2F%2Fstorage.googleapis.com%2Fproduction-ipage-v1-0-6%2F926%2F1261926%2FlwKYG8wo%2Ffd8a8662c55d49e3a0096a1eb2b5a790&methods=resize%2C600%2C5000',
    },
    {
      text: 'Top quality job, top professional, takes pride in his work, very friendly, very easy to communicate with. Would recommend without hesitation.',
      author: 'Andy Wright',
      location: 'Rickmansworth',
      rating: 5,
      image: 'https://images.builderservices.io/s/cdn/v1.0/i/m?url=https%3A%2F%2Fstorage.googleapis.com%2Fproduction-ipage-v1-0-6%2F926%2F1261926%2FlwKYG8wo%2F03aec0823f6a47f1b9131007a4847d19&methods=resize%2C600%2C5000',
    },
    {
      text: 'Daniel and his team were quick to respond, easy to deal with, and showed expertise in all various areas. The work was completed to an excellent standard and they left everything clean and tidy at the end of each day.',
      author: 'Sarah Mitchell',
      location: 'Bushey',
      rating: 5,
      image: 'https://public.readdy.ai/ai/img_res/8c32ebe2508189fc0ecfb4732c32fdc9.jpg',
    },
    {
      text: 'Totally trustworthy and reliable. Daniel decorated our entire house interior and the finish was impeccable. He is meticulous with preparation work which really shows in the final result. Highly recommended!',
      author: 'James Patterson',
      location: 'Northwood',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=casual%20natural%20photo%20of%20man%20in%20his%2040s%20relaxed%20everyday%20clothing%20friendly%20smile%20candid%20snapshot%20style%20authentic%20real%20person%20informal%20setting&width=200&height=200&seq=casual-2&orientation=squarish',
    },
    {
      text: 'We have used Brushour for several projects over the years and they never disappoint. The attention to detail is second to none. Our kitchen and hallway look brand new. Will definitely use again!',
      author: 'Emma Collins',
      location: 'Pinner',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=casual%20natural%20photo%20of%20young%20woman%20in%20her%2030s%20relaxed%20everyday%20style%20genuine%20smile%20candid%20snapshot%20authentic%20real%20person%20informal%20home%20setting&width=200&height=200&seq=casual-3&orientation=squarish',
    },
    {
      text: 'Fantastic service from start to finish. Daniel provided a detailed quote, arrived on time every day, and the quality of workmanship was outstanding. Our exterior painting looks absolutely stunning.',
      author: 'Michael Thompson',
      location: 'Radlett',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=casual%20natural%20photo%20of%20man%20in%20his%2050s%20outdoors%20relaxed%20everyday%20clothing%20warm%20smile%20candid%20snapshot%20style%20authentic%20real%20person%20informal&width=200&height=200&seq=casual-4&orientation=squarish',
    },
  ];

  const renderStars = (rating: number) => {
    return Array.from({ length: rating }, (_, i) => (
      <i key={i} className="ri-star-fill text-amber-400"></i>
    ));
  };

  return (
    <section className="py-20 px-6 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <p className="text-xs font-semibold text-primary-500 uppercase tracking-wider mb-2">Google Reviews</p>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
            What Our Customers Say
          </h2>
          <p className="text-base text-gray-500 max-w-2xl mx-auto">Real feedback from homeowners across Hertfordshire who trusted Brushour with their painting and decorating projects</p>
          <div className="flex items-center justify-center gap-2 mt-4">
            <div className="flex items-center gap-1">
              {renderStars(5)}
            </div>
            <span className="text-sm font-medium text-gray-600">5.0 rating on Google</span>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-white rounded-lg p-6 relative border border-gray-100 shadow-sm hover:shadow-md transition-shadow duration-300">
              <div className="flex items-center gap-1 mb-4">
                {renderStars(testimonial.rating)}
              </div>
              <p className="text-sm text-gray-600 leading-relaxed mb-6">
                "{testimonial.text}"
              </p>
              <div className="flex items-center gap-3 pt-4 border-t border-gray-100">
                <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0 border-2 border-primary-100">
                  <img
                    src={testimonial.image}
                    alt={testimonial.author}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div>
                  <p className="text-sm font-semibold text-gray-800">{testimonial.author}</p>
                  <p className="text-xs text-gray-500">{testimonial.location}</p>
                </div>
                <div className="ml-auto">
                  <i className="ri-google-fill text-xl text-gray-400"></i>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-10">
          <a 
            href="https://www.google.com/search?q=brushour+painters+decorators+watford+reviews" 
            target="_blank" 
            rel="nofollow noopener noreferrer"
            className="inline-flex items-center gap-2 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors cursor-pointer"
          >
            View all reviews on Google
            <i className="ri-external-link-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
